'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  input {\n    font-size: 14px !important;\n  }\n  label {\n    font-size: 14px !important;\n  }\n  hr {\n    bottom: 4px !important;\n  }\n'], ['\n  position: relative;\n  input {\n    font-size: 14px !important;\n  }\n  label {\n    font-size: 14px !important;\n  }\n  hr {\n    bottom: 4px !important;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 10px;\n  right: 2px;\n\n  cursor: pointer;\n'], ['\n  position: absolute;\n  bottom: 10px;\n  right: 2px;\n\n  cursor: pointer;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DatePicker = require('material-ui/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DatePickerWrapper = _styledComponents2.default.div(_templateObject);

DatePickerWrapper.displayName = 'DatePickerWrapper';
var CalendarIcon = _styledComponents2.default.div(_templateObject2);

CalendarIcon.displayName = 'CalendarIcon';
var formatDate = function formatDate(date) {
  return date ? (0, _format2.default)(date, 'Do MMM YYYY') : null;
  // return moment(date, 'YYYY-MM-DD').format('Do MMM YYYY');
};

var NitroDatePicker = function (_Component) {
  _inherits(NitroDatePicker, _Component);

  function NitroDatePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NitroDatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NitroDatePicker.__proto__ || Object.getPrototypeOf(NitroDatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event, value) {
      var valueString = (0, _format2.default)(value, 'YYYY-MM-DD');
      _this.props.onChange(valueString);
    }, _this.openDatePicker = function () {
      _this.datePicker.openDialog();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NitroDatePicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          floatLabel = _props.floatLabel,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          placeholder = _props.placeholder,
          shouldDisableDate = _props.shouldDisableDate,
          value = _props.value;


      var valueObject = value ? new Date(value) : null;

      return _react2.default.createElement(
        DatePickerWrapper,
        { className: className },
        _react2.default.createElement(_DatePicker2.default, {
          id: 'datepicker-' + placeholder + '-' + floatLabel,
          maxDate: maxDate,
          minDate: minDate,
          ref: function ref(_ref2) {
            return _this2.datePicker = _ref2;
          }
          // hintText={placeholder}
          , floatingLabelText: placeholder,
          value: valueObject,
          onChange: this.onChange,
          formatDate: formatDate,
          shouldDisableDate: shouldDisableDate,
          fullWidth: true
        }),
        _react2.default.createElement(
          CalendarIcon,
          { onClick: this.openDatePicker },
          _react2.default.createElement(_nitroIcon2.default, { name: 'calendar', size: 20, variant: 'secondary' })
        )
      );
    }
  }]);

  return NitroDatePicker;
}(_react.Component);

NitroDatePicker.propTypes = {
  value: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  placeholder: _react.PropTypes.string,
  shouldDisableDate: _react.PropTypes.func,
  maxDate: _react.PropTypes.object,
  minDate: _react.PropTypes.object,
  floatLabel: _react.PropTypes.string,
  className: _react.PropTypes.string
};

exports.default = NitroDatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-date-picker/NitroDatePicker.js
// module id = 2900
// module chunks = 4